import {
  FETCH_ITINERARIES, FETCH_ITINERARIES_FAIL,
} from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { SlackWebhook } from './utils';
// import { history } from '../components/app';

/**
 * Get booking information by cyoa token
 * Fetch booking via Busabout API
 *
 * @param {string} cyoaToken - cyoa secret hash
 */
export function FetchIntineraries(cyoaToken){

  const bookingURL = `${process.env.REACT_APP_ITINERARIES_API}/${cyoaToken}?api_token=${process.env.REACT_APP_API_TOKEN}`;
  const config = { withCredentials: true};

  return (dispatch) => {
    axios.get(bookingURL, config)
    .then((response) => {
      dispatch({type:FETCH_ITINERARIES, payload:response.data});
    })
    .catch((err)=>{
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Intineraries API (GET) - ' + bookingURL + " " + err}));
      // history.push('/500');
      dispatch({type:FETCH_ITINERARIES_FAIL});
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/itineraries.js